import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { BUSINESS_DETAILS_SLICE_NAME } from "./businessDetails.constants"

export const getBusinessDetails = createAsyncThunk(
  `${BUSINESS_DETAILS_SLICE_NAME}/get_business_details`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getBusinessDetails(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// The legacy saga handled this one outside `apiGeneratorBase` only so it could call the
// payload's `meta.onSuccess`/`meta.onError`; the request itself is the standard shape.
// The form now drives those two callbacks off `.unwrap()` instead.
export const updateBusinessDetails = createAsyncThunk(
  `${BUSINESS_DETAILS_SLICE_NAME}/update_business_details`,
  async ({ body, params }, { dispatch, rejectWithValue }) => {
    const response = await services.updateBusinessDetails({ body, params })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCountries = createAsyncThunk(
  `${BUSINESS_DETAILS_SLICE_NAME}/get_countries`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCountries(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
